import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  return (
    <main className="policy-page returns" aria-labelledby="returns-title">
      <header className="policy-page__intro">
        <div className="policy-page__intro-inner">
          <p className="policy-page__kicker">Customer care / Orders</p>
          <h1 id="returns-title">Returns &amp; exchanges</h1>
          <p className="policy-page__lead">
            A straightforward route to a better fit. Start your return within 28
            days of delivery and keep the product in original condition.
          </p>
          <p className="policy-page__updated">Please read the conditions below before sending an item.</p>
        </div>
      </header>

      <div className="policy-page__layout">
        <nav className="policy-page__contents" aria-label="Returns policy contents">
          <p>On this page</p>
          <a href="#returns-eligibility">Return conditions</a>
          <a href="#returns-process">How to return</a>
          <a href="#returns-exchanges">Exchanges</a>
          <a href="#returns-refunds">Refunds</a>
          <a href="#returns-faults">Faulty items</a>
        </nav>

        <article className="policy-page__content">
          <section id="returns-eligibility">
            <p className="policy-page__section-number">01</p>
            <h2>Return conditions</h2>
            <p>
              Items must be unworn, unwashed and free from scent, marks or damage,
              with all original tags and packaging attached. Please try garments on
              indoors and take particular care with rigid denim, boots and light
              colours.
            </p>
            <div className="policy-page__note">
              Hemmed, altered, personalised, worn or final-sale items cannot normally
              be returned unless they are faulty.
            </div>
          </section>

          <section id="returns-process">
            <p className="policy-page__section-number">02</p>
            <h2>How to make a return</h2>
            <ol className="policy-page__steps">
              <li>
                <strong>Request approval</strong>
                <span>
                  Email {siteConfig.contact.email} with your order number and the
                  item you wish to return.
                </span>
              </li>
              <li>
                <strong>Pack it securely</strong>
                <span>
                  Reuse the original packaging where possible and include the return
                  details supplied by our team.
                </span>
              </li>
              <li>
                <strong>Use a tracked service</strong>
                <span>
                  Keep your proof of postage until we confirm that the return has
                  been inspected.
                </span>
              </li>
            </ol>
          </section>

          <section id="returns-exchanges">
            <p className="policy-page__section-number">03</p>
            <h2>Exchanges</h2>
            <p>
              To secure another size quickly, contact us before posting your return.
              Exchange stock cannot be guaranteed, so we may recommend returning the
              original item and placing a new order.
            </p>
          </section>

          <section id="returns-refunds">
            <p className="policy-page__section-number">04</p>
            <h2>Inspection and refunds</h2>
            <p>
              Approved refunds are sent to the original payment method after the
              item is inspected. Your bank may need additional working days to show
              the credit. Original express-delivery charges and return postage are
              not refunded unless the item was faulty or sent in error.
            </p>
          </section>

          <section id="returns-faults" className="policy-page__callout">
            <p className="policy-page__section-number">05</p>
            <h2>Something is not right?</h2>
            <p>
              Send clear photographs and your order number to{" "}
              <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
              We will review the issue before asking you to return the item.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Returns;
